import React from 'react';
import { TagStyled } from './Styled';

interface TagProps {
  children: string;
  selected: boolean;
  onClick: (e: any) => void;
  fontSize?: number;
}

const Tag: React.FC<TagProps> = (props: TagProps) => {
  const { fontSize = 16, onClick, children, selected } = props;
  const className = selected ? 'active' : '';

  return (
    <TagStyled fontSize={fontSize} onClick={onClick} className={className}>
      {children}
    </TagStyled>
  );
};

Tag.defaultProps = {
  children: '',
  selected: false,
};

export default Tag;
export { Tag };
